/**
 * Session ID: one per browser tab (sessionStorage); new session when tab closes.
 */

import {
  OBSERVABILITY_ENABLED,
  SESSION_ID_STORAGE_KEY,
} from './constants';

const STORAGE = typeof sessionStorage !== 'undefined' ? sessionStorage : null;

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getOrCreateSessionIdStorage(): string {
  if (!OBSERVABILITY_ENABLED || !STORAGE) {
    return '';
  }
  let id = STORAGE.getItem(SESSION_ID_STORAGE_KEY);
  if (!id || typeof id !== 'string') {
    id = generateUUID();
    try {
      STORAGE.setItem(SESSION_ID_STORAGE_KEY, id);
    } catch {
      // ignore
    }
  }
  return id;
}

let cachedSessionId: string | null = null;

export function getSessionId(): string {
  if (cachedSessionId !== null) {
    return cachedSessionId;
  }
  cachedSessionId = getOrCreateSessionIdStorage();
  return cachedSessionId;
}

/** Call once at bootstrap to ensure session_id exists. */
export function ensureSessionId(): string {
  return getSessionId();
}
